import * as React from 'react';
import text from '../../../utils/text';
import { SERVICES_LEVEL_0, SERVICES_LEVEL_1 } from '../../../utils/utils';
import SelectWithLabel from '../SelectWithLabel/SelectWithLabel';

interface Props {
  value: { service: string; fonction?: string };
  onChange: (value: any) => void;
  enableFonction: boolean;
  error?: boolean;
  mandatory?: boolean;
}

interface State {
  service: any;
  fonction: any;
  showFonction: boolean;
}

export default class ServiceSelector extends React.Component<Props, State> {
  state = { service: null, fonction: null, showFonction: false };

  handleLevel0Change = (service: any) => {
    // disable function

    // const showFonction = (service !== null && SERVICES_LEVEL_1[service.value] !== undefined) ;
    // this.setState({ service, showFonction, fonction: null });

    this.setState({ service });
    this.props.onChange({ value: service.value });
  };

  handleLevel1Change = (fonction: any) => {
    const service = this.state.service !== null ? (this.state.service as any).value : '';
    this.setState({ fonction });
    if (fonction == null) {
      this.props.onChange({ service, fonction: '' });
    } else {
      this.props.onChange({ service, fonction: fonction.value });
    }
  };

  public render() {
    return (
      <div className="limited-width">
        <SelectWithLabel
          className="select mandatory-select"
          classNamePrefix="select"
          value={this.state.service}
          onChange={this.handleLevel0Change}
          options={SERVICES_LEVEL_0}
          error={this.props.error && this.state.service == null}
          placeholder={text.select_service}
          mandatory={true}
          id="select-service"
        />
        {this.state.showFonction && this.state.service !== null && (
          <SelectWithLabel
            className={'select' + (this.props.mandatory ? ' mandatory-select' : '')}
            classNamePrefix="select"
            value={this.state.fonction}
            onChange={this.handleLevel1Change}
            options={SERVICES_LEVEL_1[(this.state.service as any).value]}
            error={this.props.mandatory && this.props.error && this.state.fonction == null}
            placeholder={text.select_function}
            id="select-fonction"
          />
        )}
      </div>
    );
  }
}
